import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { dsColorNew } from "@palette"
import { AppInsuranceAutocomplete } from "@components/Autocomplete"
import { BACKEND_APIS } from "@constants"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData, dsRepricingOriginalData } from "Pages/DsRepricing/Page/@signals"
import { enrichFilterIds } from "Pages/DsRepricing/Page/@utils/filterEnrich"
import { useAxisCatalog } from "Pages/DsRepricing/Setup/@services/axes"

// The insurance axis of the face scope (CU-869fe6mf4): the same shape as
// the providers and categories filters — switch + multi picker — on the
// catalogue Rate cards reads (`options/insurance`). The catalogue is the
// tenant's and may be empty; the picker says so instead of opening on
// nothing, which is how the Sites axis once stayed broken unnoticed.
export default function DsRepricingFilterInsurances() {
	const d = dsRepricingDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useDsRepricingDataInfo(d.filterInsurances ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useDsRepricingDataInfo(d.filterInsurancesExclusion ?? false)
	const axes = useAxisCatalog()

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []
	const noCatalogue = !axes.loading && axes.insurances.length === 0

	const updateMode = (checked) => setExcl(checked, 'filterInsurancesExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterInsurances')

	const placeholder = axes.loading ? 'Loading insurance…'
	                  : noCatalogue  ? 'No insurance catalogue for this tenant'
	                  : isExclusion  ? 'All insurance except…' : 'All insurance'

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => updateMode(e.target.checked)} size="small"/>
				<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 500 }}>
					{isExclusion ? 'Exclude insurance' : 'Include insurance'}
				</Typography>
			</Box>
			<AppInsuranceAutocomplete
				multiple
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/insurance`}
				label="Insurance"
				placeholder={placeholder}
				disabled={axes.loading || noCatalogue}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterInsurances', options, dsRepricingDrawerData, dsRepricingOriginalData); return options }}
			/>
		</Box>
	)
}
